module.exports = __webpack_public_path__ + "static/media/box.54cdb52a.png";